import * as React from 'react';

export const MinimalEgg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.735 10.231c0 5.376-3.644 9.733-8.14 9.733S.454 15.607.454 10.231 4.611.498 8.594.498c4.497 0 8.141 4.357 8.141 9.733Z"
      fill="url(#a)"
    />
    <path
      d="M16.735 10.231c0 5.376-3.644 9.733-8.14 9.733S.454 15.607.454 10.231 4.611.498 8.594.498c4.497 0 8.141 4.357 8.141 9.733Z"
      fill="url(#b)"
      style={{
        mixBlendMode: 'overlay',
      }}
    />
    <path
      d="M16.735 10.231c0 5.376-3.644 9.733-8.14 9.733S.454 15.607.454 10.231 4.611.498 8.594.498c4.497 0 8.141 4.357 8.141 9.733Z"
      fill="#D9A625"
      style={{
        mixBlendMode: 'color',
      }}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.595 19.451c4.13 0 7.627-4.038 7.627-9.22s-3.497-9.22-7.627-9.22c-1.807 0-3.711.994-5.178 2.675a10.01 10.01 0 0 0-2.45 6.545c0 5.182 3.497 9.22 7.628 9.22Zm0 .513c4.495 0 8.14-4.357 8.14-9.733S13.091.498 8.595.498C4.61.498.454 4.855.454 10.23s3.645 9.733 8.14 9.733Z"
      fill="#fff"
      fillOpacity={0.7}
    />
    <path
      d="M16.735 10.231c0 5.376-3.644 9.733-8.14 9.733S.454 15.607.454 10.231 4.611.498 8.594.498c4.497 0 8.141 4.357 8.141 9.733Z"
      fill="url(#c)"
    />
    <path
      d="M16.735 10.231c0 5.376-3.644 9.733-8.14 9.733S.454 15.607.454 10.231 4.611.498 8.594.498c4.497 0 8.141 4.357 8.141 9.733Z"
      fill="url(#d)"
      style={{
        mixBlendMode: 'overlay',
      }}
    />
    <path
      d="M16.735 10.231c0 5.376-3.644 9.733-8.14 9.733S.454 15.607.454 10.231 4.611.498 8.594.498c4.497 0 8.141 4.357 8.141 9.733Z"
      fill="#D9A625"
      style={{
        mixBlendMode: 'color',
      }}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.595 19.451c4.13 0 7.627-4.038 7.627-9.22s-3.497-9.22-7.627-9.22c-1.807 0-3.711.994-5.178 2.675a10.01 10.01 0 0 0-2.45 6.545c0 5.182 3.497 9.22 7.628 9.22Zm0 .513c4.495 0 8.14-4.357 8.14-9.733S13.091.498 8.595.498C4.61.498.454 4.855.454 10.23s3.645 9.733 8.14 9.733Z"
      fill="#fff"
      fillOpacity={0.7}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.78 12.851c1.476.706 3.532 1.15 5.815 1.15 2.282 0 4.338-.444 5.814-1.15 1.493-.714 2.318-1.656 2.318-2.62h.462c0 1.245-1.047 2.303-2.58 3.037-1.552.741-3.678 1.194-6.014 1.194-2.337 0-4.463-.453-6.014-1.194C1.047 12.534 0 11.475 0 10.23h.462c0 .964.825 1.906 2.318 2.62ZM8.595 6.462c-.279 0-.554.007-.826.02a.23.23 0 0 1-.022-.462 17.864 17.864 0 0 1 1.695 0 .23.23 0 1 1-.022.462c-.271-.013-.547-.02-.825-.02ZM6.48 6.358a.23.23 0 0 1-.196.26c-.579.081-1.13.191-1.646.327a.23.23 0 1 1-.118-.447c.536-.14 1.105-.254 1.7-.337a.23.23 0 0 1 .26.197Zm4.227 0a.23.23 0 0 1 .26-.197 14.72 14.72 0 0 1 1.7.337.231.231 0 0 1-.117.447 14.262 14.262 0 0 0-1.646-.326.23.23 0 0 1-.197-.26ZM3.4 7.093a.23.23 0 0 1-.127.3 7.205 7.205 0 0 0-1.567.853.23.23 0 0 1-.274-.372 7.663 7.663 0 0 1 1.667-.908.23.23 0 0 1 .301.127Zm10.445.022a.23.23 0 0 1 .302-.126 7.694 7.694 0 0 1 1.552.843.23.23 0 1 1-.27.375 7.233 7.233 0 0 0-1.458-.79.23.23 0 0 1-.126-.302Z"
      fill="#202020"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.741 17.229c.595-1.78.968-4.255.968-6.998 0-2.744-.373-5.218-.968-6.998-.298-.891-.648-1.596-1.026-2.073-.379-.48-.76-.698-1.12-.698V0c.562 0 1.062.341 1.483.874.423.534.794 1.294 1.1 2.213.616 1.839.993 4.364.993 7.144 0 2.78-.377 5.305-.992 7.144-.307.919-.678 1.678-1.101 2.213-.421.533-.921.874-1.484.874V20c.362 0 .742-.219 1.121-.698.378-.477.728-1.182 1.026-2.073ZM5.48 10.23c0 .336.005.667.016.993a.231.231 0 0 1-.461.015 30.37 30.37 0 0 1 0-2.015.23.23 0 0 1 .461.015c-.01.327-.016.658-.016.993Zm-.12 2.571a.23.23 0 0 1 .252.207c.067.696.16 1.36.274 1.981a.23.23 0 1 1-.454.083 24.261 24.261 0 0 1-.28-2.019.23.23 0 0 1 .207-.252Zm0-5.14a.23.23 0 0 1-.208-.253c.069-.707.163-1.383.28-2.019a.23.23 0 0 1 .454.083 23.804 23.804 0 0 0-.274 1.981.23.23 0 0 1-.253.208Zm.62 8.814a.23.23 0 0 1 .284.16c.21.735.452 1.373.72 1.89a.23.23 0 1 1-.41.212 10.744 10.744 0 0 1-.754-1.976.23.23 0 0 1 .16-.286ZM5.996 3.92a.23.23 0 0 1-.157-.286c.201-.698.436-1.318.698-1.84a.23.23 0 1 1 .413.208c-.247.49-.472 1.082-.668 1.76a.23.23 0 0 1-.286.158Z"
      fill="#202020"
    />
    <defs>
      <linearGradient
        id="a"
        x1={-0.544}
        y1={16.383}
        x2={27.436}
        y2={6.128}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#576265" />
        <stop offset={0.172} stopColor="#9EA1A1" />
        <stop offset={0.457} stopColor="#848B8A" />
        <stop offset={0.554} stopColor="#576265" />
        <stop offset={0.823} stopColor="#576265" />
        <stop offset={0.925} stopColor="#757A7B" />
        <stop offset={1} stopColor="#576265" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={6.953}
        y1={10.231}
        x2={2.553}
        y2={0.626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={-0.544}
        y1={16.383}
        x2={27.436}
        y2={6.128}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#576265" />
        <stop offset={0.172} stopColor="#9EA1A1" />
        <stop offset={0.457} stopColor="#848B8A" />
        <stop offset={0.554} stopColor="#576265" />
        <stop offset={0.823} stopColor="#576265" />
        <stop offset={0.925} stopColor="#757A7B" />
        <stop offset={1} stopColor="#576265" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={6.953}
        y1={10.231}
        x2={2.553}
        y2={0.626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>
);
